import React from 'react';
import styles from './CheckboxLabel.module.scss';

const getInitial = (name) => (name ? ` ${name.substring(0, 1)}.` : '');

const CheckboxLabel = ({ worker }) => {
  const name = `${worker.surName}${getInitial(worker.firstName)}${getInitial(
    worker.partName
  )}`;

  return (
    <span className={styles.root}>
      {name && (
        <>
          <span className={styles.nameWrap}>
            {worker.specialityName && (
              <span className={styles.speciality}>{worker.specialityName}</span>
            )}
            {name}
          </span>
        </>
      )}
      <span className={styles.requestCount}>{worker.requestCount}</span>
    </span>
  );
};

export default CheckboxLabel;
